module.exports = __webpack_public_path__ + "officialStatic/img/rlmjDetailList1.9499338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/rlmjDetailList1.png
// module id = EkCk
// module chunks = 0